exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".yxt-biz-relationDynamicUserGroup .yxt-alert--info.is-light{background-color:#F0F6FF;color:#262626}.yxt-biz-relationDynamicUserGroup .yxt-alert__content{padding:0 16px 0 24px}\n", ""]);

